<div
  class="upload-area"
  [class.dragging]="isDragging"
  [class.disabled]="disabled"
  (click)="openFileDialog()"
>
  <input
    #fileInput
    type="file"
    class="file-input"
    [accept]="acceptedExtensions"
    multiple
    (change)="onFileInputChange($event)"
  />

  <div class="upload-content">
    <div class="upload-icon-wrapper">
      <i class="fa-solid fa-cloud-arrow-up upload-icon"></i>
    </div>

    <div class="upload-text" *ngIf="!isUploading">
      <p class="upload-title">{{ "documents.dragDropText" | translate }}</p>
      <p class="upload-subtitle">
        {{ "documents.supportedFormats" | translate }}
      </p>
    </div>

    <div class="upload-progress" *ngIf="isUploading">
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">{{ "loading" | translate }}...</span>
      </div>
      <span class="uploading-text">{{ "loading" | translate }}...</span>
    </div>

    <button
      type="button"
      class="btn btn-primary add-btn"
      [disabled]="disabled || isUploading"
    >
      <i class="fa-solid fa-plus"></i>
      <span>{{ "documents.upload" | translate }}</span>
    </button>
  </div>
</div>
